import { TRASHIE_GA_TAG_ID } from '../config/config';

import { isProd } from '../../../config/config';

const tagId = isProd() ? TRASHIE_GA_TAG_ID.PRODUCTION : TRASHIE_GA_TAG_ID.STAGING;
const debugMode = isProd() ? '' : ', debug_mode: true';

// Consent Mode v2 regional defaults: denied for EU/UK/CA, granted for everyone else
const consentDefault = `
gtag('consent', 'default', {
  'ad_storage': 'denied',
  'ad_user_data': 'denied',
  'ad_personalization': 'denied',
  'analytics_storage': 'denied',
  'security_storage': 'granted',
  'region': ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR',
    'DE','GR','HU','IE','IT','LV','LT','LU','MT','NL',
    'PL','PT','RO','SK','SI','ES','SE','IS','LI','NO','GB','US-CA']
});
gtag('consent', 'default', {
  'ad_storage': 'granted',
  'ad_user_data': 'granted',
  'ad_personalization': 'granted',
  'analytics_storage': 'granted'
});`;

const script = `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
${consentDefault}
gtag('js', new Date());
(function() {
  var configOpts = { cookie_domain: '.trashie.io'${debugMode} };
  // Read UTMs from cross-domain cookie so shop→app navigations keep attribution
  try {
    var cm = document.cookie.match(/(?:^|;\\s*)utm_params_global=([^;]+)/);
    if (cm) {
      var raw = JSON.parse(decodeURIComponent(cm[1]));
      var utms = raw.params ? raw.params : raw;
      var src = utms.utm_source || '';
      var med = utms.utm_medium || '';
      // Derive source/medium from click IDs when no explicit UTMs
      if (!src && (utms.gclid || utms.gbraid || utms.wbraid)) { src = 'google'; med = 'cpc'; }
      if (!src && utms.fbclid) { src = 'meta'; med = 'cpc'; }
      if (!src && utms.msclkid) { src = 'microsoft'; med = 'cpc'; }
      if (!src && utms.ttclid) { src = 'tiktok'; med = 'cpc'; }
      if (src) configOpts.campaign_source = src;
      if (med) configOpts.campaign_medium = med;
      if (utms.utm_campaign) configOpts.campaign_name = utms.utm_campaign;
      if (utms.utm_term) configOpts.campaign_term = utms.utm_term;
      if (utms.utm_content) configOpts.campaign_content = utms.utm_content;
    }
  } catch(e) {}
  // URL UTMs override cookie — GA4 auto-parses them from the URL,
  // so only set from cookie when URL has no utm_source
  if (window.location.search.indexOf('utm_source') > -1) {
    configOpts = { cookie_domain: '.trashie.io'${debugMode} };
  }
  gtag('config', '${tagId}', configOpts);
})();`;

export default script;
